// frontend/src/features/citysense/housing-stock-modeller/components/LegendBar.tsx

import React from 'react';
import { ViewMode } from '../types';
import { DEPRIVATION_LEVELS } from '../constants/housingConfig';

interface Props {
  viewMode: ViewMode;
  archetypeColors: Map<string, string>;
  showUpgradedLegend: boolean;
}

export const LegendBar: React.FC<Props> = ({ viewMode, archetypeColors, showUpgradedLegend }) => {
  // Fix broken diamond characters
  const cleanArchetypeName = (name: string) => name.replace(/�/g, "◆");

  if (viewMode === 'deprivation') {
    const levels = Object.values(DEPRIVATION_LEVELS).sort((a, b) => a.order - b.order);
    return (
      <div className="bg-white border-2 border-blue-200 rounded-lg p-4">
        <h4 className="text-sm font-bold text-gray-700 mb-3">Deprivation Index</h4>
        <div className="flex flex-wrap gap-2">
          {levels.map((level) => (
            <div key={level.label} className="flex items-center gap-2">
              <div
                className="w-6 h-6 rounded border-2 border-white shadow-sm"
                style={{ backgroundColor: level.fill }}
              />
              <span className="text-xs text-gray-700">{level.label}</span>
            </div>
          ))}
        </div>
      </div>
    );
  }

  // Archetype legend - show first 10
  const archetypes = Array.from(archetypeColors.entries()).slice(0, 10);

  return (
    <div className="bg-white border-2 border-teal-200 rounded-lg p-4">
      <h4 className="text-sm font-bold text-gray-700 mb-3">
        Housing Archetypes {archetypes.length < archetypeColors.size && `(showing ${archetypes.length} of ${archetypeColors.size})`}
      </h4>
      <div className="flex flex-wrap gap-3">
        {archetypes.map(([archetype, color]) => (
          <div key={archetype} className="flex items-center gap-2 max-w-sm">
            <div
              className="w-6 h-6 rounded border-2 border-white shadow-sm flex-shrink-0"
              style={{ backgroundColor: color }}
            />
            <span className="text-xs text-gray-700 leading-tight" title={archetype}>
              {cleanArchetypeName(archetype)}
            </span>
          </div>
        ))}
      </div>
      {showUpgradedLegend && (
        <div className="mt-3 pt-3 border-t border-gray-200">
          <div className="flex items-center gap-2">
            <span className="text-xl">⭐</span>
            <span className="text-xs font-semibold text-amber-600">Upgraded by Optimizer</span>
          </div>
        </div>
      )}
    </div>
  );
};